import { render, staticRenderFns } from "./ContractQuickView.vue?vue&type=template&id=6b55d2a0&scoped=true&"
import script from "./ContractQuickView.vue?vue&type=script&lang=js&"
export * from "./ContractQuickView.vue?vue&type=script&lang=js&"
import style0 from "./ContractQuickView.vue?vue&type=style&index=0&id=6b55d2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55d2a0",
  null
  
)

export default component.exports